const TenderData = {
  "Transporte de Carga": {
    tituloEjemplo: "Transporte de carga para productos perecederos",
    descripcionEjemplo:
      "Se requiere servicio de transporte de carga refrigerada para productos perecederos desde la planta de producción hasta puntos de distribución en la ciudad. El proveedor debe garantizar condiciones óptimas de temperatura y puntualidad...",
  },
  "Mantenimiento y Limpieza": {
    tituloEjemplo:
      "Mantenimiento preventivo y limpieza de equipos industriales",
    descripcionEjemplo:
      "Buscamos servicios de mantenimiento y limpieza especializada para nuestros equipos industriales en planta. Esto incluye la limpieza profunda de maquinaria y mantenimiento básico de sistemas de ventilación y filtros...",
  },
  "Marketing y Publicidad": {
    tituloEjemplo:
      "Reclutamiento de agencia para campaña de branding y eventos",
    descripcionEjemplo:
      "Estamos buscando una agencia de marketing y publicidad para desarrollar una campaña integral de branding. La agencia debe ser capaz de gestionar desde la conceptualización de la identidad visual, diseño de material POP, creación de logotipos, hasta la organización de eventos promocionales. Se valorará experiencia previa en el sector y habilidades en diseño creativo...",
  },
  Agricultura: {
    tituloEjemplo: "Servicios de producción y distribución agrícola",
    descripcionEjemplo:
      "Se necesita un proveedor especializado en distribución de productos agrícolas. Idealmente, con experiencia en el manejo de productos frescos y en garantizar entregas puntuales a mercados locales e internacionales...",
  },
  "Arquitectura y Diseño de interiores": {
    tituloEjemplo: "Diseño y planificación de interiores",
    descripcionEjemplo:
      "Requerimos un estudio de arquitectura para rediseñar el espacio interior de nuestras oficinas principales, garantizando funcionalidad y estética moderna...",
  },
  "Alimentos y Bebidas": {
    tituloEjemplo: "Producción y distribución de alimentos orgánicos",
    descripcionEjemplo:
      "Buscamos un socio estratégico para la producción y distribución de alimentos orgánicos, con un enfoque en productos sostenibles y de alta calidad...",
  },
  Banca: {
    tituloEjemplo: "Servicios financieros para pymes",
    descripcionEjemplo:
      "Requerimos servicios bancarios especializados para pequeñas y medianas empresas, con soluciones innovadoras para préstamos y financiamiento...",
  },
  "Bienes Raíces": {
    tituloEjemplo: "Gestión y venta de propiedades comerciales",
    descripcionEjemplo:
      "Estamos buscando un socio para gestionar la venta y alquiler de propiedades comerciales en zonas urbanas clave...",
  },
  "Comercio y E-commerce": {
    tituloEjemplo: "Desarrollo de plataforma de comercio electrónico",
    descripcionEjemplo:
      "Se necesita una empresa que diseñe y desarrolle una plataforma de e-commerce optimizada para una experiencia de usuario fluida...",
  },
  "Consultoría Empresarial": {
    tituloEjemplo: "Consultoría en estrategia empresarial",
    descripcionEjemplo:
      "Buscamos consultores experimentados para ayudarnos a redefinir nuestra estrategia empresarial y alcanzar nuevos mercados...",
  },
  Construcción: {
    tituloEjemplo: "Edificación de infraestructura comercial",
    descripcionEjemplo:
      "Requerimos servicios de construcción para la edificación de una nueva sede comercial, con enfoque en sostenibilidad...",
  },
  "Contabilidad y Auditoría": {
    tituloEjemplo: "Auditoría financiera anual",
    descripcionEjemplo:
      "Se necesita una firma de auditoría para realizar la revisión completa de nuestras cuentas anuales...",
  },
  "Diseño Gráfico y Multimedia": {
    tituloEjemplo: "Creación de identidad visual corporativa",
    descripcionEjemplo:
      "Requerimos un diseñador gráfico para crear una nueva identidad visual para nuestra marca, incluyendo logotipo y material promocional...",
  },
  "Desarrollo de Software": {
    tituloEjemplo: "Desarrollo de software a medida",
    descripcionEjemplo:
      "Buscamos una empresa que desarrolle un software personalizado para la gestión interna de procesos en nuestra organización...",
  },
  "Educación Inicial, Primaria y Secundaria": {
    tituloEjemplo: "Material educativo digital",
    descripcionEjemplo:
      "Requerimos un proveedor para el desarrollo de material educativo interactivo para estudiantes de nivel inicial y primario...",
  },
  "Educación Superior": {
    tituloEjemplo: "Software de gestión académica",
    descripcionEjemplo:
      "Estamos buscando un sistema integral de gestión académica para universidades e institutos superiores...",
  },
  Energía: {
    tituloEjemplo: "Suministro de energía renovable",
    descripcionEjemplo:
      "Se requiere un proveedor de energía renovable para garantizar el suministro sostenible a nuestras instalaciones...",
  },
  Hotelería: {
    tituloEjemplo: "Gestión de reservas hoteleras",
    descripcionEjemplo:
      "Buscamos un sistema de gestión para optimizar las reservas en nuestra cadena hotelera...",
  },
  "Industria Textil": {
    tituloEjemplo: "Producción y distribución de textiles",
    descripcionEjemplo:
      "Requerimos servicios de fabricación y distribución de textiles personalizados para nuestra línea de productos...",
  },
  "Logística y Distribución": {
    tituloEjemplo: "Optimización de cadena logística",
    descripcionEjemplo:
      "Buscamos una empresa especializada en logística para mejorar la eficiencia en la distribución de nuestros productos...",
  },
  "Materiales para Construcción": {
    tituloEjemplo: "Suministro de materiales de construcción",
    descripcionEjemplo:
      "Requerimos un proveedor confiable de materiales de construcción para grandes proyectos residenciales...",
  },
  "Medio Ambiente y Sostenibilidad": {
    tituloEjemplo: "Consultoría en sostenibilidad",
    descripcionEjemplo:
      "Se necesita una consultora ambiental para implementar políticas de sostenibilidad en nuestras operaciones...",
  },
  "Minería y Extracción": {
    tituloEjemplo: "Servicios de extracción minera",
    descripcionEjemplo:
      "Buscamos proveedores para servicios especializados en minería y extracción de recursos naturales...",
  },
  "Pesca y Acuicultura": {
    tituloEjemplo: "Producción sostenible en acuicultura",
    descripcionEjemplo:
      "Se requiere un socio estratégico para desarrollar prácticas sostenibles en la producción de productos acuícolas...",
  },
  "Salud y Medicina": {
    tituloEjemplo: "Suministro de equipos médicos",
    descripcionEjemplo:
      "Requerimos un proveedor confiable para la distribución de equipos médicos para hospitales y clínicas...",
  },
  "Servicios de Seguridad": {
    tituloEjemplo: "Provisión de sistemas de seguridad",
    descripcionEjemplo:
      "Estamos buscando un proveedor de equipos y servicios de seguridad para nuestras instalaciones corporativas...",
  },
  "Tecnología Financiera (Fintech)": {
    tituloEjemplo: "Soluciones tecnológicas para banca",
    descripcionEjemplo:
      "Buscamos un socio tecnológico que implemente soluciones innovadoras en el sector financiero...",
  },
  "Turismo y Agencias de Viaje": {
    tituloEjemplo: "Desarrollo de paquetes turísticos personalizados",
    descripcionEjemplo:
      "Se necesita una agencia de viajes para diseñar paquetes turísticos enfocados en experiencias locales únicas...",
  },
};

export default TenderData;
